import { createAppSlice } from '../createAppSlice';
import { Message } from '@/enums/message.enum';
import { MESSAGE } from '@/constants/message.constant';
import { MessageType } from '@/types/common';
import { transformerObject } from '../transformer';
type PageSliceState = {
  loading: boolean;
  listPage?: HomePageUs;
  message?: MessageType;
};

const initialState: PageSliceState = {
  loading: false
};

export const pageSlice = createAppSlice({
  name: 'page',
  initialState,
  reducers: (create) => ({
    getPageByValue: create.asyncThunk(
      async (value: string) => {
        const response = await apiFetcher.get(
          `page?code=HP_CLIENT&value=${value}`
        );
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.listPage = transformerObject(action.payload[0]);
        },
        rejected: (state) => {
          state.loading = false;
          state.listPage = undefined;
        }
      }
    ),
    createHomePageUs: create.asyncThunk(
      async (data: HomePageUsProps) => {
        try {
          const response = await apiFetcher.post('page/create', data);
          return response;
        } catch (error) {
          return error;
        }
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state) => {
          state.loading = false;
          state.message = {
            type: Message.SUCCESS,
            message: MESSAGE.CREATE_HOME_PAGE_US_SUCCESS
          };
        },
        rejected: (state) => {
          state.loading = false;
          state.message = {
            type: Message.ERROR,
            message: MESSAGE.CREATE_HOME_PAGE_US_FAIL
          };
        }
      }
    )
  }),
  selectors: {
    watchPageByValue: (pageByValue) => pageByValue.listPage,
    watchPageMessage: (page) => page.message,
    watchPageLoading: (page) => page.loading
  }
});

export const { watchPageByValue, watchPageMessage, watchPageLoading } =
  pageSlice.selectors;

export const { createHomePageUs, getPageByValue } = pageSlice.actions;
